import type { Static } from 'runtypes';
import * as rt from 'runtypes';

const UserPlanOverviewRuntype = rt.Record({
  accessed_briefs: rt.Array(rt.Number),
  first_name: rt.String,
  last_name: rt.String,
  user_organizations: rt.Array(rt.String),
  user_groups: rt.Array(rt.String),
  email: rt.String,
  name: rt.String,
  job_title: rt.Optional(rt.String),
  rank: rt.Optional(rt.String),
  organization: rt.Optional(rt.String),
  parent_organization: rt.Optional(rt.String),
  org_names: rt.Optional(rt.Array(rt.String)),
  group_names: rt.Optional(rt.Array(rt.String)),
  starttime: rt.InstanceOf(Date),
  endtime: rt.InstanceOf(Date),
});

type UserPlanOverviewType = Static<typeof UserPlanOverviewRuntype>;

export { UserPlanOverviewRuntype };
export type { UserPlanOverviewType };
